import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';

function ProtectedRoute({ children, allowedRoles, allowedDepartments }) {
    const { user } = useContext(AuthContext);

    if (!user) {
        return <Navigate to="/" />; // Redirect to login if not authenticated
    }

    if (allowedRoles) {
        const userRole = String(user.Auth || '').trim().toLowerCase();
        const userDepartment = String(user.Department || '').trim().toLowerCase();
        const normalizedRoles = allowedRoles.map(role => String(role).trim().toLowerCase());
        const normalizedDepartments = (allowedDepartments || []).map(department => String(department).trim().toLowerCase());
        const roleAllowed = normalizedRoles.includes(userRole);
        const departmentAllowed = normalizedDepartments.includes(userDepartment);

        if (!roleAllowed && !departmentAllowed) {
            return <Navigate to="/" />;
        }
    }

    return children;
}

export default ProtectedRoute;
